/* ==========================================================================
   Bendito Equilibrio — Coach de bienestar
   --------------------------------------------------------------------------
   Diez preguntas, un informe de bienestar y el kit que arma ese mismo
   diagnóstico. El kit NO es uno de los cuatro kits fijos: son exactamente los
   productos que salieron recomendados, y su precio es la suma de los precios
   reales del catálogo.

   El espectro es una nube de ~1.700 partículas: se dibuja una silueta humana
   en un lienzo fuera de pantalla, se leen sus píxeles y cada uno se convierte
   en una partícula que viaja hasta su sitio con el scroll. No hay modelo ni
   imagen que descargar.

   Los sonidos se sintetizan con Web Audio, así que tampoco hay audio que
   descargar, y se pueden silenciar desde la propia sección.

   Archivo suelto a propósito, fuera del bundle de src/be-landing: esta sección
   no comparte estado con la landing y se puede tocar sin recompilarla.
   ========================================================================== */

(() => {
  'use strict';

  /* Cada sección emite su propia etiqueta <script src>. El navegador la
     descarga una vez pero EJECUTA cada etiqueta, así que hace falta guardia,
     igual que en be-landing.js. */
  if (window.__beCoachBooted) return;
  window.__beCoachBooted = true;

  const raiz = document.querySelector('[data-be-coach]');
  if (!raiz) return;

  /* Precios, variantes y rutas de imagen los pone Liquid desde el catálogo
     real. Aquí no se escribe ni un peso a mano. */
  const nodoDatos = raiz.querySelector('[data-be-coach-datos]');
  const CFG = nodoDatos ? JSON.parse(nodoDatos.textContent) : { imgs: {}, prods: {}, urlTarjeta: '/checkout' };

  /* ======================================================================
     1. CATÁLOGO — los 14 productos reales
     ----------------------------------------------------------------------
     `img` apunta a los recortes transparentes que ya usan el carrusel y la
     esfera de kits (assets/be-p-*.webp). No se genera ninguna imagen nueva.
     `uso` es orientativo y hay que contrastarlo con la etiqueta del envase
     antes de publicar.
     ====================================================================== */
  /* `precio` y `antes` son los del catálogo real de la tienda, leídos de
     /collections/all/products.json. En la sección Liquid los pondrá Shopify;
     aquí van fijos solo para poder probar. Ningún número es inventado: el
     "antes" es el compare_at_price que ya tienen los productos. */
  const PRODUCTOS = {
    melatonina:      { nom: 'Melatonina 12 mg',                corto: 'Melatonina',      img: 'melatonina',            precio: 70000,  antes: 89000, vid: 45306740047981, por: 'para conciliar el sueño más rápido',            uso: '1 cápsula 30 minutos antes de dormir.',           dims: ['descanso'] },
    bisglicinato:    { nom: 'Bisglicinato de Magnesio 600 mg', corto: 'Magnesio',        img: 'bisglicinato-magnesio', precio: 67000,  antes: 89000, vid: 45306869481581, por: 'relaja el músculo y acompaña el descanso',      uso: '2 cápsulas en la noche, con o sin comida.',       dims: ['descanso', 'cuerpo'] },
    ashwagandha:     { nom: 'Ashwagandha 5500 mg',             corto: 'Ashwagandha',     img: 'ashwagandha',           precio: 60000,  antes: 79000, vid: 45306969489517, por: 'ayuda a bajar revoluciones en el día',          uso: '1 cápsula al día, preferiblemente en la mañana.', dims: ['calma'] },
    supermagnesio:   { nom: 'Super Magnesio + Ashwagandha',    corto: 'Super Magnesio',  img: 'super-magnesio',        precio: 68000,  antes: 89000, vid: 45306576863341, por: 'descanso completo en una sola cápsula',         uso: '1 cápsula en la noche, antes de acostarte.',      dims: ['descanso', 'calma'] },
    nad:             { nom: 'NAD+ con Resveratrol',            corto: 'NAD+',            img: 'nad-resveratrol',       precio: 73000,  antes: 89900, vid: 45307047805037, por: 'energía celular y vitalidad',                   uso: '1 cápsula en la mañana, con el desayuno.',        dims: ['energia'] },
    creatina:        { nom: 'Creatina Monohidratada Pura USP', corto: 'Creatina',        img: 'creatina',              precio: 100000, antes: 120000, vid: 45307080081517, por: 'fuerza y rendimiento en el entrenamiento',     uso: '1 medida (5 g) al día en agua o jugo.',           dims: ['cuerpo'] },
    colageno:        { nom: 'Colágeno Hidrolizado Premium',    corto: 'Colágeno',        img: 'colageno-hidrolizado',  precio: 100000, antes: 120000, vid: 45307075887213, por: 'piel firme y articulaciones que aguantan',     uso: '1 medida (10 g) al día en agua, jugo o café.',    dims: ['belleza', 'cuerpo'] },
    multivitaminico: { nom: 'Multivitamínico Premium',         corto: 'Multivitamínico', img: 'multivitaminico',       precio: 69000,  antes: 89000, vid: 45307040694381, por: 'la base diaria que casi nadie cubre con comida',uso: '1 cápsula al día con el desayuno.',               dims: ['energia'] },
    omega:           { nom: 'Omega 3 Premium 1300 mg',         corto: 'Omega 3',         img: 'omega-3',               precio: 68000,  antes: 89000, vid: 45307055079533, por: 'corazón, mente y recuperación',                uso: '1 a 2 cápsulas al día con las comidas.',          dims: ['mente', 'cuerpo'] },
    melena:          { nom: 'Melena de León',                  corto: 'Melena de León',  img: 'melena-de-leon',        precio: 70000,  antes: 89000, vid: 45306983612525, por: 'foco y claridad mental sostenida',             uso: '1 cápsula al día con el desayuno.',               dims: ['mente'] },
    probioticos:     { nom: 'Probióticos + Prebióticos + Zinc',corto: 'Probióticos',     img: 'probioticos',           precio: 70000,  antes: 89000, vid: 45307070742637, por: 'equilibra tu flora intestinal',                uso: '1 cápsula al día en ayunas.',                     dims: ['digestion'] },
    vinagre:         { nom: 'Vinagre de Sidra de Manzana',     corto: 'Vinagre',         img: 'vinagre-manzana',       precio: 70000,  antes: 89000, vid: 45307051933805, por: 'digestión más ligera después de comer',        uso: '1 cápsula antes de las comidas principales.',     dims: ['digestion'] },
    vitaminad:       { nom: 'Vitamina D Premium',              corto: 'Vitamina D',      img: 'vitamina-d',            precio: 68000,  antes: 89000, vid: 45307064909933, por: 'defensas y ánimo, sobre todo si te da poco sol',uso: '1 cápsula al día con una comida.',                dims: ['energia'] },
    biotina:         { nom: 'Biotina Premium',                 corto: 'Biotina',         img: 'biotina',               precio: 68000,  antes: 68000, vid: 45307043348589, por: 'cabello y uñas más fuertes',                   uso: '1 cápsula al día con el desayuno.',               dims: ['belleza'] }
  };
  /* Los recortes transparentes son los mismos assets be-p-*.webp del carrusel
     y de la esfera de kits. Si faltara alguno, el <img> queda vacío en vez de
     romper la sección. */
  const imagenDe = (clave) => CFG.imgs[clave] || '';

  /* Ya no hay lista de kits prefabricados. El kit lo arma el diagnóstico con
     los mismos productos que acaba de recomendar: ofrecer un kit de belleza a
     quien salió con la energía por el piso era incoherente, y era exactamente
     lo que pasaba al elegir uno de los cuatro kits fijos. */
  /* Los precios de PRODUCTOS son solo un respaldo para poder probar el archivo
     suelto. En la tienda mandan los de Liquid: si un producto sube de precio o
     se le quita el descuento, la sección lo refleja sin tocar código. */
  Object.keys(PRODUCTOS).forEach((k) => {
    const real = CFG.prods && CFG.prods[PRODUCTOS[k].img];
    if (!real) return;
    PRODUCTOS[k].precio = real.precio;
    PRODUCTOS[k].antes = real.antes || real.precio;
    PRODUCTOS[k].vid = real.vid;
  });

  const formatCOP = (n) => '$' + Math.round(n).toLocaleString('es-CO');

  /* ======================================================================
     2. DIMENSIONES
     ----------------------------------------------------------------------
     Los colores se mantienen dentro de la familia del logo —aqua #7FD4D8,
     menta #00E5A0, teal #054D56— para que el cambio de atmósfera por pregunta
     no saque la sección de la identidad de la marca.
     ====================================================================== */
  const DIMS = {
    descanso:  { lbl: 'Descanso',  color: '#2f86a8' },
    calma:     { lbl: 'Calma',     color: '#5aacc4' },
    energia:   { lbl: 'Energía',   color: '#00e5a0' },
    cuerpo:    { lbl: 'Cuerpo',    color: '#2fcf9c' },
    digestion: { lbl: 'Digestión', color: '#57d08a' },
    belleza:   { lbl: 'Belleza',   color: '#9fe0d4' },
    mente:     { lbl: 'Mente',     color: '#7fd4d8' }
  };
  const ORDEN_DIMS = ['descanso', 'calma', 'energia', 'cuerpo', 'digestion', 'belleza', 'mente'];

  /* ======================================================================
     3. LAS 10 PREGUNTAS
     ----------------------------------------------------------------------
     `sis`  → sistema que se enciende dentro del cuerpo
     `foco` → [y, radio] en coordenadas del modelo (y de -1 arriba a 1 abajo)
     ====================================================================== */
  const PREGUNTAS = [
    { tema: 'PERFIL', q: '¿Con qué te identificas?', cols: 2, acc: '#7fd4d8', sis: null, foco: [-0.3, 0.9], pie: 'Leyendo tu perfil',
      ops: [
        { t: 'Mujer',               d: {}, p: { colageno: 1.2, biotina: 1.2 } },
        { t: 'Hombre',              d: {}, p: { creatina: 1.2, nad: 0.6 } },
        { t: 'Prefiero no decirlo', d: {}, p: {} }
      ] },
    { tema: 'EDAD', q: '¿En qué rango de edad estás?', cols: 2, acc: '#4fb8c4', sis: 'oseo', foco: [-0.2, 0.95], pie: 'Ajustando el análisis',
      ops: [
        { t: '18 a 29 años',  d: { energia: 4 },  p: { creatina: 1, multivitaminico: 0.8 } },
        { t: '30 a 44 años',  d: {},              p: { nad: 1, colageno: 1, multivitaminico: 0.8 } },
        { t: '45 a 59 años',  d: { energia: -4 }, p: { nad: 2, colageno: 1.6, vitaminad: 1.2, multivitaminico: 1 } },
        { t: '60 años o más', d: { energia: -6 }, p: { nad: 2.4, colageno: 1.8, vitaminad: 1.6, omega: 1.2 } }
      ] },
    { tema: 'DESCANSO', q: '¿Cómo duermes últimamente?', acc: '#2f86a8', sis: 'nervioso', foco: [-0.85, 0.28], pie: 'Analizando tu descanso',
      ops: [
        { t: 'Profundo, y despierto descansado',      d: { descanso: 26, energia: 8 },   p: {} },
        { t: 'Duermo, pero despierto sin batería',    d: { descanso: 2, energia: -8 },   p: { bisglicinato: 1.6, multivitaminico: 1, vitaminad: 1 } },
        { t: 'Doy vueltas antes de poder dormirme',   d: { descanso: -12, calma: -8 },   p: { melatonina: 2.4, supermagnesio: 1.6, ashwagandha: 1 } },
        { t: 'Me despierto varias veces en la noche', d: { descanso: -18, energia: -6 }, p: { melatonina: 2, bisglicinato: 2, supermagnesio: 2 } }
      ] },
    { tema: 'CALMA', q: '¿Cómo llevas el estrés del día a día?', acc: '#5aacc4', sis: 'nervioso', foco: [-0.55, 0.6], pie: 'Midiendo tu carga',
      ops: [
        { t: 'Tranquilo la mayor parte del tiempo',     d: { calma: 26 },                 p: {} },
        { t: 'Con tensión solo en semanas fuertes',     d: { calma: 6 },                  p: { ashwagandha: 1, bisglicinato: 0.8 } },
        { t: 'Casi siempre acelerado',                  d: { calma: -14, descanso: -6 },  p: { ashwagandha: 2.4, bisglicinato: 1.4 } },
        { t: 'Me cuesta desconectar, incluso de noche', d: { calma: -20, descanso: -10 }, p: { ashwagandha: 2.4, supermagnesio: 2, melatonina: 1.2 } }
      ] },
    { tema: 'ENERGÍA', q: '¿Cómo es tu energía durante el día?', acc: '#00e5a0', sis: 'circul', foco: [-0.5, 0.34], pie: 'Midiendo tu energía',
      ops: [
        { t: 'Constante de la mañana a la noche',         d: { energia: 26 },                p: {} },
        { t: 'Bien temprano, me caigo en la tarde',       d: { energia: 2 },                 p: { nad: 1.6, multivitaminico: 1.2 } },
        { t: 'Necesito café para arrancar',               d: { energia: -12 },               p: { nad: 2, vitaminad: 1.4, multivitaminico: 1.2 } },
        { t: 'Me levanto igual de cansado que me acosté', d: { energia: -20, descanso: -8 }, p: { nad: 2.4, vitaminad: 2, multivitaminico: 1.6, bisglicinato: 1 } }
      ] },
    { tema: 'CUERPO', q: '¿Cuánto te mueves en una semana normal?', acc: '#2fcf9c', sis: 'muscular', foco: [-0.15, 0.95], pie: 'Evaluando tu actividad',
      ops: [
        { t: 'Entreno 4 veces o más',       d: { cuerpo: 26, energia: 6 },   p: { creatina: 2.4, colageno: 1.4, multivitaminico: 1 } },
        { t: 'Dos o tres veces por semana', d: { cuerpo: 12 },               p: { creatina: 1.4, multivitaminico: 1 } },
        { t: 'Camino, poco más',            d: { cuerpo: -6 },               p: { multivitaminico: 1.2, vitaminad: 1.2, omega: 1 } },
        { t: 'Prácticamente nada',          d: { cuerpo: -16, energia: -6 }, p: { multivitaminico: 1.6, vitaminad: 1.8, omega: 1.2 } }
      ] },
    { tema: 'RECUPERACIÓN', q: 'Después de un esfuerzo, ¿cómo responde tu cuerpo?', acc: '#6fdcc0', sis: 'oseo', foco: [0.4, 0.5], pie: 'Revisando tu recuperación',
      ops: [
        { t: 'Me recupero rápido, sin molestias',         d: { cuerpo: 20 },               p: {} },
        { t: 'Quedo adolorido un par de días',            d: { cuerpo: -6 },               p: { creatina: 1.4, colageno: 1.4, bisglicinato: 1.2 } },
        { t: 'Siento rodillas, espalda o articulaciones', d: { cuerpo: -16 },              p: { colageno: 2.4, omega: 2 } },
        { t: 'Me cuesta mantener el ritmo del día',       d: { cuerpo: -12, energia: -8 }, p: { nad: 1.6, creatina: 1.2, multivitaminico: 1 } }
      ] },
    { tema: 'DIGESTIÓN', q: '¿Cómo te sientes después de comer?', acc: '#57d08a', sis: 'digestivo', foco: [-0.18, 0.32], pie: 'Analizando tu digestión',
      ops: [
        { t: 'Ligero, sin molestias',          d: { digestion: 26 },               p: {} },
        { t: 'Me hincho con frecuencia',       d: { digestion: -14 },              p: { probioticos: 2.4, vinagre: 1.6 } },
        { t: 'Voy al baño de forma irregular', d: { digestion: -16 },              p: { probioticos: 2.4, vinagre: 1.2 } },
        { t: 'Pesadez casi siempre',           d: { digestion: -20, energia: -6 }, p: { probioticos: 2, vinagre: 2, multivitaminico: 0.8 } }
      ] },
    { tema: 'BELLEZA', q: '¿Cómo están tu piel, tu cabello y tus uñas?', acc: '#9fe0d4', sis: null, foco: [-0.7, 0.45], pie: 'Leyendo tu vitalidad',
      ops: [
        { t: 'Fuertes y con brillo',                   d: { belleza: 26 },  p: {} },
        { t: 'El cabello se me cae o está sin fuerza', d: { belleza: -16 }, p: { biotina: 2.4, colageno: 1.6 } },
        { t: 'Piel seca o apagada',                    d: { belleza: -14 }, p: { colageno: 2.4, omega: 1.4, nad: 1 } },
        { t: 'Uñas quebradizas',                       d: { belleza: -12 }, p: { biotina: 2.4, multivitaminico: 1 } }
      ] },
    { tema: 'MENTE', q: '¿Cómo anda tu concentración y tu memoria?', acc: '#7fd4d8', sis: 'nervioso', foco: [-0.86, 0.3], pie: 'Cerrando el análisis',
      ops: [
        { t: 'Enfocado, con memoria clara',           d: { mente: 26 },               p: {} },
        { t: 'Me disperso con facilidad',             d: { mente: -12 },              p: { melena: 2.4, omega: 1.4 } },
        { t: 'Se me olvidan cosas del día',           d: { mente: -16 },              p: { melena: 2.4, omega: 1.8, nad: 1 } },
        { t: 'Niebla mental, sobre todo en la tarde', d: { mente: -18, energia: -8 }, p: { melena: 2.4, nad: 1.6, omega: 1.2 } }
      ] }
  ];

  const ACC_INTRO = '#7fd4d8';
  const ACC_FINAL = '#00e5a0';

  /* Cinco colores para las diez preguntas: uno cada dos.
     Antes cada pregunta traía su propio acento, pero ocho de los diez eran
     variaciones de teal y menta, así que el recorrido se percibía como dos
     colores. Estos cinco se distinguen de verdad y siguen siendo fríos y
     calmados, anclados en los dos de la marca (aqua y menta). */
  const PALETA = [
    '#7fd4d8', // 1-2  aqua de marca
    '#2c6fb5', // 3-4  azul profundo
    '#7c6bd6', // 5-6  violeta
    '#00e5a0', // 7-8  menta de marca
    '#62c98a', // 9-10 verde salvia
  ];
  const acentoDe = (i) => PALETA[Math.min(PALETA.length - 1, Math.floor(i / 2))];

  const $ = (s, c) => (c || document).querySelector(s);
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const lerp = (a, b, t) => a + (b - a) * t;
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const hexRGB = (h) => [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)];
  const rgba = (c, a) => `rgba(${c[0]},${c[1]},${c[2]},${a})`;
  const menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ======================================================================
     SONIDO
     ----------------------------------------------------------------------
     Los tonos se sintetizan con Web Audio: ni un archivo que descargar, y así
     no hay latencia la primera vez que suenan.

     Todos son la misma idea —una gota— con distinta altura y caída: un seno
     que baja de tono con una envolvente suave y un filtro que le quita el
     filo. Es lo que hace que se perciban como calma y no como interfaz de
     videojuego.

     El navegador no deja crear audio sin un gesto del usuario, así que el
     contexto nace en el primer clic. Y queda un botón para silenciar, que se
     recuerda entre visitas: el sonido sin salida es lo que hace que la gente
     cierre la pestaña.
     ====================================================================== */
  const sonido = (() => {
    const LLAVE = 'be-coach-sonido';
    let ctx = null;
    let maestro = null;
    let activo = true;
    try { activo = localStorage.getItem(LLAVE) !== 'off'; } catch (e) { /* modo privado */ }

    function arrancar() {
      if (!activo) return null;
      if (!ctx) {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        ctx = new AC();
        maestro = ctx.createGain();
        maestro.gain.value = 0.5;
        maestro.connect(ctx.destination);
      }
      if (ctx.state === 'suspended') ctx.resume();
      return ctx;
    }

    /**
     * Una gota.
     * @param {number} f0    altura inicial en Hz
     * @param {number} f1    altura final
     * @param {number} dur   duración en segundos
     * @param {number} vol   volumen 0..1
     * @param {number} atras retraso desde ahora
     */
    function gota(f0, f1, dur, vol, atras) {
      const c = arrancar();
      if (!c) return;
      const t0 = c.currentTime + (atras || 0);

      const osc = c.createOscillator();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(f0, t0);
      osc.frequency.exponentialRampToValueAtTime(Math.max(40, f1), t0 + dur * 0.9);

      // El filtro es lo que separa una gota de un pitido.
      const filtro = c.createBiquadFilter();
      filtro.type = 'lowpass';
      filtro.frequency.setValueAtTime(f0 * 3, t0);
      filtro.frequency.exponentialRampToValueAtTime(Math.max(200, f1 * 1.6), t0 + dur);
      filtro.Q.value = 0.9;

      const g = c.createGain();
      g.gain.setValueAtTime(0.0001, t0);
      g.gain.exponentialRampToValueAtTime(vol, t0 + 0.012);   // ataque suave
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);  // caída larga

      osc.connect(filtro); filtro.connect(g); g.connect(maestro);
      osc.start(t0);
      osc.stop(t0 + dur + 0.02);
    }

    /** Cuenco: dos senos casi iguales que baten entre sí y caen muy lento. Ese
        batido es lo que da el timbre de cuenco y no de pitido. */
    function cuenco(f, dur, vol, desafine) {
      const d = desafine === undefined ? 0.011 : desafine;
      gota(f, f * 0.985, dur, vol, 0);
      gota(f * (1 + d), f * (1 + d) * 0.985, dur * 1.06, vol * 0.75, 0.02);
    }

    /** Burbuja: sube de tono con un pasabanda estrecho que barre con ella. El
        ascenso es lo que se lee como "vamos a algún lado". */
    function burbuja(f0, f1, dur, vol, atras) {
      const c = arrancar();
      if (!c) return;
      const t0 = c.currentTime + (atras || 0);

      const osc = c.createOscillator();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(f0, t0);
      osc.frequency.exponentialRampToValueAtTime(f1, t0 + dur * 0.85);

      const bp = c.createBiquadFilter();
      bp.type = 'bandpass';
      bp.Q.value = 4.5;
      bp.frequency.setValueAtTime(f0, t0);
      bp.frequency.exponentialRampToValueAtTime(f1, t0 + dur * 0.85);

      const g = c.createGain();
      g.gain.setValueAtTime(0.0001, t0);
      g.gain.exponentialRampToValueAtTime(vol, t0 + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);

      osc.connect(bp); bp.connect(g); g.connect(maestro);
      osc.start(t0); osc.stop(t0 + dur + 0.02);
    }

    return {
      /** Primer gesto: despierta el audio sin sonar. */
      despertar() { arrancar(); },
      /** Opción elegida. */
      toque() { gota(760, 430, 0.42, 0.16, 0); },
      /** Se pasa a la siguiente pregunta: una gota más grave, medio paso después. */
      paso() { gota(520, 300, 0.55, 0.12, 0.06); },
      /** Aparece el informe: cuenco. Es el cierre del test, no un paso más. */
      informe() { cuenco(528, 1.5, 0.10); cuenco(792, 1.1, 0.045, 0.08); },
      /** Se despliega el kit: cuenco corto, porque también es una decisión. */
      abrir() { cuenco(660, 0.85, 0.075); },
      /** Se va a otra página (carrito, checkout): burbuja ascendente. */
      ir() { burbuja(300, 900, 0.36, 0.11, 0); burbuja(460, 1250, 0.42, 0.06, 0.07); },
      /** Volver atrás. */
      atras() { gota(420, 300, 0.34, 0.10, 0); },

      get activo() { return activo; },
      alternar() {
        activo = !activo;
        try { localStorage.setItem(LLAVE, activo ? 'on' : 'off'); } catch (e) { /* modo privado */ }
        if (activo) { arrancar(); gota(660, 500, 0.35, 0.13, 0); }
        else if (ctx) { ctx.suspend(); }
        return activo;
      }
    };
  })();


  /* ======================================================================
     4. EL ESPECTRO — nube de partículas
     ----------------------------------------------------------------------
     Se dibuja una silueta humana en un lienzo fuera de pantalla, se leen sus
     píxeles y cada uno se convierte en una partícula que viaja desde una
     posición dispersa hasta su sitio. No hay modelo 3D ni imagen: son ~1.400
     puntos atraídos a su destino.

     Con el recorrido del scroll el cuerpo se materializa; cada pregunta
     enciende su zona (cabeza, pecho, abdomen, miembros) en el color de la
     pregunta, y el cursor empuja y aviva las partículas que tiene cerca.
     ====================================================================== */
  function crearEspectro(caja, lienzo) {
    const ctx = lienzo.getContext('2d');
    let W = 0, H = 0, dpr = 1, particulas = [], raf = 0, t = 0, paso = 6;
    const estilos = [];   // caché de colores, se rehace en cada fotograma

    const est = {
      revelado: 0, revelObj: 0,       // 0 = disperso, 1 = cuerpo formado
      focoY: 0.5, focoR: 0,           // franja encendida, en coords de la caja
      acc: hexRGB(ACC_INTRO), accObj: hexRGB(ACC_INTRO),
      mx: -9999, my: -9999,
      pulso: 0
    };

    /* Caja del cuerpo: proporción fija 0.5 centrada en el lienzo. Sin esto,
       en un contenedor ancho el cuerpo saldría achatado. */
    const PROP = 0.5;
    function caja3(w, h) {
      const bw = Math.min(w, h * PROP);
      const bh = bw / PROP;
      return { bw, bh, ox: (w - bw) / 2, oy: (h - bh) / 2 };
    }

    /* --- silueta: cabeza, cuello, torso, brazos y piernas ---------------- */
    function dibujarCuerpo(c, w, h) {
      const B = caja3(w, h);
      const x = (n) => B.ox + n * B.bw;
      const y = (n) => B.oy + n * B.bh;
      c.clearRect(0, 0, w, h);
      c.fillStyle = '#fff';
      c.strokeStyle = '#fff';
      c.lineCap = 'round';
      c.lineJoin = 'round';

      // cabeza
      c.beginPath();
      c.ellipse(x(0.5), y(0.062), B.bw * 0.105, B.bh * 0.055, 0, 0, Math.PI * 2);
      c.fill();

      // cuello
      c.lineWidth = B.bw * 0.105;
      c.beginPath();
      c.moveTo(x(0.5), y(0.104));
      c.lineTo(x(0.5), y(0.135));
      c.stroke();

      // torso: hombros anchos que bajan a cintura y se abren en cadera
      c.beginPath();
      c.moveTo(x(0.315), y(0.158));
      c.quadraticCurveTo(x(0.5), y(0.132), x(0.685), y(0.158));
      c.quadraticCurveTo(x(0.640), y(0.262), x(0.605), y(0.330));
      c.quadraticCurveTo(x(0.640), y(0.380), x(0.638), y(0.430));
      c.lineTo(x(0.362), y(0.430));
      c.quadraticCurveTo(x(0.360), y(0.380), x(0.395), y(0.330));
      c.quadraticCurveTo(x(0.360), y(0.262), x(0.315), y(0.158));
      c.closePath();
      c.fill();

      // brazos, separados del costado
      c.lineWidth = B.bw * 0.115;
      [[-1, 0.330], [1, 0.670]].forEach(([s, hx]) => {
        c.beginPath();
        c.moveTo(x(hx), y(0.175));
        c.quadraticCurveTo(x(hx + s * 0.085), y(0.270), x(hx + s * 0.115), y(0.360));
        c.quadraticCurveTo(x(hx + s * 0.135), y(0.410), x(hx + s * 0.128), y(0.452));
        c.stroke();
      });

      // piernas
      c.lineWidth = B.bw * 0.165;
      [[-1, 0.437], [1, 0.563]].forEach(([s, hx]) => {
        c.beginPath();
        c.moveTo(x(hx), y(0.420));
        c.quadraticCurveTo(x(hx + s * 0.012), y(0.560), x(hx + s * 0.026), y(0.680));
        c.quadraticCurveTo(x(hx + s * 0.038), y(0.800), x(hx + s * 0.034), y(0.905));
        c.stroke();
      });

      // pies
      c.lineWidth = B.bw * 0.10;
      [[-1, 0.403], [1, 0.597]].forEach(([s, hx]) => {
        c.beginPath();
        c.moveTo(x(hx), y(0.930));
        c.lineTo(x(hx + s * 0.055), y(0.945));
        c.stroke();
      });
    }

    /* --- muestreo: píxeles → partículas ---------------------------------- */
    function construir() {
      const off = document.createElement('canvas');
      off.width = W; off.height = H;
      const oc = off.getContext('2d', { willReadFrequently: true });
      dibujarCuerpo(oc, W, H);
      const px = oc.getImageData(0, 0, W, H).data;
      const B = caja3(W, H);

      paso = Math.max(3, Math.round(B.bw / 62));
      const nuevas = [];
      for (let yy = 0; yy < H; yy += paso) {
        for (let xx = 0; xx < W; xx += paso) {
          if (px[(yy * W + xx) * 4 + 3] > 60) {
            const jx = xx + (Math.random() - 0.5) * paso * 0.9;
            const jy = yy + (Math.random() - 0.5) * paso * 0.9;
            const ang = Math.random() * Math.PI * 2;
            const rad = Math.max(B.bw, B.bh) * (0.35 + Math.random() * 0.6);
            nuevas.push({
              tx: jx, ty: jy,                                   // destino
              ox: W / 2 + Math.cos(ang) * rad,                  // origen disperso
              oy: H / 2 + Math.sin(ang) * rad * 0.7,
              // normalizadas respecto a la CAJA, no al lienzo: así la franja
              // encendida apunta siempre a la misma parte del cuerpo
              nx: (jx - B.ox) / B.bw,
              ny: (jy - B.oy) / B.bh,
              f: 0,
              fase: Math.random() * Math.PI * 2,
              /* Escalonado: cada partícula arranca algo después que la
                 anterior, pero TODAS llegan cuando revelado = 1. Con un
                 multiplicador, las lentas se quedaban a medio camino y el
                 cuerpo no terminaba de leerse nunca. */
              retraso: Math.random() * 0.4,
              g: 0.6 + Math.random() * 0.8
            });
          }
        }
      }
      particulas = nuevas;
    }

    function medir() {
      const r = caja.getBoundingClientRect();
      if (!r.width || !r.height) return false;
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = Math.round(r.width * dpr);
      H = Math.round(r.height * dpr);
      lienzo.width = W;
      lienzo.height = H;
      construir();
      return true;
    }

    /* --- bucle ------------------------------------------------------------ */
    function pintar() {
      t += 0.016;
      est.revelado = lerp(est.revelado, est.revelObj, 0.055);
      est.pulso *= 0.94;
      for (let i = 0; i < 3; i++) est.acc[i] = lerp(est.acc[i], est.accObj[i], 0.05);

      ctx.clearRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';

      const base = hexRGB('#7fd4d8');
      const acc = est.acc;
      const rev = est.revelado;
      const B = caja3(W, H);
      const gx = B.ox + B.bw * 0.5, gy = B.oy + B.bh * 0.3;

      // resplandor detrás del cuerpo
      const g = ctx.createRadialGradient(gx, gy, 0, gx, gy, B.bw * 0.9);
      g.addColorStop(0, rgba(acc, 0.10 * rev + est.pulso * 0.07));
      g.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, W, H);

      /* Caché de estilos. Componer una cadena "rgba(...)" por partícula y por
         fotograma cuesta más que dibujarlas: se cuantiza el encendido en 12
         pasos y el alfa en 16, y se reutiliza. */
      const cache = estilos;
      cache.length = 0;
      for (let ci = 0; ci < 12; ci++) {
        const m = ci / 11;
        const cr = Math.round(lerp(base[0], acc[0], m));
        const cg = Math.round(lerp(base[1], acc[1], m));
        const cb = Math.round(lerp(base[2], acc[2], m));
        const fila = new Array(16);
        for (let ai = 0; ai < 16; ai++) fila[ai] = `rgba(${cr},${cg},${cb},${((ai + 1) / 16).toFixed(3)})`;
        cache.push(fila);
      }

      const respira = menosMovimiento ? 0 : Math.sin(t * 0.9) * 0.004;
      const radioCursor = 150 * dpr;

      for (let i = 0; i < particulas.length; i++) {
        const p = particulas[i];

        // franja de la pregunta: 0 fuera, 1 en el centro
        let fObj = 0;
        if (est.focoR > 0.001) {
          const d = Math.abs(p.ny - est.focoY);
          if (d < est.focoR) fObj = 1 - d / est.focoR;
        }
        p.f = lerp(p.f, fObj, 0.06);

        // posición: origen → destino según el revelado
        const e = clamp((rev - p.retraso) / 0.6, 0, 1);
        const suave = e * e * (3 - 2 * e);
        let px = lerp(p.ox, p.tx, suave);
        let py = lerp(p.oy, p.ty, suave);

        if (!menosMovimiento) {
          px += Math.sin(t * 1.1 + p.fase) * 1.1 * dpr;
          py += Math.cos(t * 0.85 + p.fase) * 1.1 * dpr;
          px += (px - gx) * respira;
          py += (py - gy) * respira;
        }

        // el cursor empuja y enciende
        let luz = 0;
        const dxm = px - est.mx, dym = py - est.my;
        const dm2 = dxm * dxm + dym * dym;
        if (dm2 < radioCursor * radioCursor) {
          const dm = Math.sqrt(dm2) || 1;
          luz = 1 - dm / radioCursor;
          px += (dxm / dm) * luz * 11 * dpr;
          py += (dym / dm) * luz * 11 * dpr;
        }

        const enc = clamp(p.f + luz * 0.8 + est.pulso * 0.5, 0, 1);
        const centelleo = menosMovimiento ? 1 : 0.78 + Math.sin(t * 2.2 + p.fase) * 0.22;
        const a = (0.24 + enc * 0.42) * clamp(rev * 1.15, 0, 1) * centelleo;
        if (a < 0.015) continue;

        /* El radio se ata a la separación entre puntos, no a un valor fijo.
           Con un tamaño fijo, al encoger el lienzo la separación bajaba pero
           el punto no, los puntos se solapaban y, sumándose en modo lighter,
           el cuerpo se quemaba a blanco en móvil. */
        const r = Math.max(0.8, (0.30 + enc * 0.26) * paso * p.g);

        const fila = cache[Math.min(11, (enc * 11 + 0.5) | 0)];
        ctx.fillStyle = fila[Math.min(15, (a * 16) | 0)];
        ctx.fillRect(px - r * 0.5, py - r * 0.5, r, r);

        // halo solo en las muy encendidas: son pocas y dan todo el brillo
        if (enc > 0.55) {
          const ah = (enc - 0.55) * 0.22;
          if (ah > 0.02) {
            ctx.fillStyle = fila[Math.min(15, (ah * 16) | 0)];
            const rh = r * 2.6;
            ctx.fillRect(px - rh * 0.5, py - rh * 0.5, rh, rh);
          }
        }
      }

      /* Barrido de escaneo: una banda de luz recorre el cuerpo de arriba abajo.
         Es lo que le da lectura de "análisis en curso", y cuesta un degradado
         por fotograma. */
      if (!menosMovimiento && rev > 0.2) {
        const ciclo = (t * 0.22) % 1.7;                // 1 s de barrido, 0.7 de pausa
        if (ciclo < 1) {
          const by = B.oy + ciclo * B.bh;
          const alto = B.bh * 0.09;
          const fuerza = Math.sin(ciclo * Math.PI) * 0.45 * rev;
          const gb = ctx.createLinearGradient(0, by - alto, 0, by + alto);
          gb.addColorStop(0, 'rgba(0,0,0,0)');
          gb.addColorStop(0.5, rgba(acc, fuerza));
          gb.addColorStop(1, 'rgba(0,0,0,0)');
          ctx.fillStyle = gb;
          ctx.fillRect(B.ox, by - alto, B.bw, alto * 2);
        }
      }

      /* Bloom: desenfocar UNA vez la imagen ya pintada y sumarla. Poner un halo
         por partícula serían 1.700 desenfoques por fotograma. */
      if (!menosMovimiento && rev > 0.05) {
        ctx.filter = 'blur(5px)';
        ctx.globalAlpha = 0.34;
        ctx.drawImage(lienzo, 0, 0);
        ctx.filter = 'none';
        ctx.globalAlpha = 1;
      }

      // Reflejo en el suelo: apoya la figura en vez de dejarla flotando.
      const piso = B.oy + B.bh * 0.97;
      const gp = ctx.createRadialGradient(gx, piso, 0, gx, piso, B.bw * 0.7);
      gp.addColorStop(0, rgba(acc, 0.22 * rev));
      gp.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.save();
      ctx.translate(gx, piso);
      ctx.scale(1, 0.15);
      ctx.translate(-gx, -piso);
      ctx.fillStyle = gp;
      ctx.fillRect(gx - B.bw * 0.7, piso - B.bw * 0.7, B.bw * 1.4, B.bw * 1.4);
      ctx.restore();

      ctx.globalCompositeOperation = 'source-over';
      raf = requestAnimationFrame(pintar);
    }

    /* --- API para el test ------------------------------------------------- */
    return {
      iniciar() {
        if (!medir()) { requestAnimationFrame(() => this.iniciar()); return; }
        if (window.ResizeObserver) {
          let tmr = 0;
          new ResizeObserver(() => { clearTimeout(tmr); tmr = setTimeout(medir, 180); }).observe(caja);
        }
        if (!raf) pintar();
      },
      revelar(v) { est.revelObj = clamp(v, 0, 1); },
      cursor(x, y) {
        const r = caja.getBoundingClientRect();
        if (!r.width) return;
        est.mx = (x - r.left) * dpr;
        est.my = (y - r.top) * dpr;
      },
      salir() { est.mx = -9999; est.my = -9999; },
      /* Las preguntas describen su foco como [y, radio] con y de -1 (cabeza) a
         1 (pies); aquí la caja va de 0 a 1, así que se convierte. */
      escena(sis, foco, color) {
        est.accObj = hexRGB(color);
        est.pulso = 1;
        if (foco) {
          est.focoY = clamp((foco[0] + 1) / 2, 0, 1);
          est.focoR = Math.max(0.06, foco[1] * 0.45);
        } else {
          est.focoR = 0;
        }
      }
    };
  }

  /* ======================================================================
     5. EL TEST
     ====================================================================== */
  const seccion = raiz;

  const panel   = $('[data-panel]', seccion);
  const cajaKit = $('[data-kitpanel]', seccion);
  const eyebrow = $('[data-eyebrow]', seccion);
  const pie     = $('[data-pie]', seccion);
  const bgs     = seccion.querySelectorAll('.be-bg');
  const caja = $('[data-anat]', seccion);
  const espectro = crearEspectro(caja, $('[data-lienzo]', seccion));

  let paso = -1;
  let capaBg = 0;
  const respuestas = new Array(PREGUNTAS.length).fill(null);

  function fondo(hex) {
    const rgb = hexRGB(hex);
    const otra = capaBg === 0 ? 1 : 0;
    bgs[otra].style.backgroundImage =
      `radial-gradient(120% 85% at 22% 18%, ${rgba(rgb, 0.3)} 0%, transparent 58%),` +
      `radial-gradient(95% 75% at 82% 78%, ${rgba(rgb, 0.16)} 0%, transparent 62%),` +
      `radial-gradient(140% 110% at 50% 50%, rgba(4,23,27,0.15) 0%, #04171b 76%)`;
    bgs[otra].style.opacity = '1';
    bgs[capaBg].style.opacity = '0';
    capaBg = otra;
    seccion.style.setProperty('--acc', hex);
    seccion.style.setProperty('--glow', rgba(rgb, 0.32));
  }

  let ptrRaf = 0, pX = 0, pY = 0, dentro = false;
  seccion.addEventListener('pointermove', (ev) => {
    pX = ev.clientX; pY = ev.clientY;
    if (!dentro) { dentro = true; seccion.dataset.pointer = 'true'; }
    if (ptrRaf) return;
    ptrRaf = requestAnimationFrame(() => {
      ptrRaf = 0;
      const r = seccion.getBoundingClientRect();
      seccion.style.setProperty('--mx', ((pX - r.left) / r.width * 100).toFixed(2) + '%');
      seccion.style.setProperty('--my', ((pY - r.top) / r.height * 100).toFixed(2) + '%');
      espectro.cursor(pX, pY);
    });
  });
  seccion.addEventListener('pointerleave', () => {
    dentro = false;
    seccion.dataset.pointer = 'false';
    espectro.salir();
  });

  /* El cuerpo se materializa con el recorrido del scroll y ya no se deshace
     una vez empieza el test. */
  /* En móvil no hay cursor, así que el dedo no puede pasear la luz por el
     cuerpo: lo hace el scroll. No se condiciona a detectar el tipo de puntero
     —los emuladores y los portátiles táctiles mienten en esa consulta—, sino a
     que el cursor NO esté sobre la sección. Así el móvil siempre lo recibe, y
     en escritorio la luz ya viene recorriendo el cuerpo antes de que el
     visitante toque el ratón; en cuanto lo mueve, manda el ratón. */
  function alDesplazar() {
    const r = seccion.getBoundingClientRect();
    const vh = window.innerHeight || 800;
    const v = clamp((vh - r.top) / (vh * 0.7), 0, 1);
    espectro.revelar(paso >= 0 ? 1 : v);

    if (!dentro) {
      const f = caja.getBoundingClientRect();
      if (f.height) {
        // 0 cuando la figura entra por abajo, 1 cuando sale por arriba
        const avance = clamp((vh - f.top) / (vh + f.height), 0, 1);
        espectro.cursor(f.left + f.width * 0.5, f.top + f.height * avance);
      }
    }
  }
  let scRaf = 0;
  window.addEventListener('scroll', () => {
    if (scRaf) return;
    scRaf = requestAnimationFrame(() => { scRaf = 0; alDesplazar(); });
  }, { passive: true });
  window.addEventListener('resize', alDesplazar);

  function montar(html, despues) {
    const vieja = panel.firstElementChild;
    const poner = () => {
      panel.innerHTML = html;
      const nueva = panel.firstElementChild;
      if (nueva) nueva.dataset.anim = 'in';
      if (despues) despues(nueva);
    };
    if (vieja && !menosMovimiento) {
      vieja.dataset.anim = 'out';
      setTimeout(poner, 220);
    } else { poner(); }
  }

  function verIntro() {
    paso = -1;
    seccion.classList.remove('is-activo');
    cajaKit.innerHTML = '';
    fondo(ACC_INTRO);
    espectro.escena(null, [-0.2, 1.1], ACC_INTRO);
    eyebrow.textContent = 'DIAGNÓSTICO EN 60 SEGUNDOS';
    pie.textContent = 'Esperando tu primera respuesta';
    alDesplazar();

    montar(`
      <div class="be-card">
        <p class="be-q__tema">CÓMO FUNCIONA</p>
        <h3 class="be-q__texto">Diez preguntas. Un perfil hecho a tu medida.</h3>
        <ul class="be-intro__lista">
          <li><span class="be-intro__ico"></span><span>Respondes <b>10 preguntas</b> sobre sueño, energía, cuerpo, digestión y mente.</span></li>
          <li><span class="be-intro__ico"></span><span>Obtienes tu <b>índice de bienestar</b> y el detalle en siete áreas.</span></li>
          <li><span class="be-intro__ico"></span><span>Te decimos <b>cuáles de nuestros 14 productos</b> encajan contigo, y cuáles no.</span></li>
        </ul>
        <div class="be-acciones"><button type="button" class="be-btn" data-empezar>EMPEZAR MI DIAGNÓSTICO</button></div>
        <span class="be-card__nota">Sin registro y sin correo. Es una guía de bienestar, no un diagnóstico médico.</span>
      </div>
    `, (card) => {
      $('[data-empezar]', card).addEventListener('click', () => {
        sonido.despertar();
        sonido.abrir();
        irA(0);
      });
    });
  }

  function irA(i) {
    paso = i;
    seccion.classList.add('is-activo');
    cajaKit.innerHTML = '';
    const P = PREGUNTAS[i];
    // El acento sale de la paleta por tramos, no del acento propio de la
    // pregunta: así el recorrido pasa por cinco colores nítidos.
    const acc = acentoDe(i);
    fondo(acc);
    espectro.escena(P.sis, P.foco, acc);
    eyebrow.textContent = 'PREGUNTA ' + (i + 1) + ' DE ' + PREGUNTAS.length;
    pie.textContent = P.pie;
    alDesplazar();

    const ops = P.ops.map((o, k) => `
      <button type="button" class="be-op" data-op="${k}" aria-pressed="${respuestas[i] === k ? 'true' : 'false'}">
        <span class="be-op__punto"></span><span>${esc(o.t)}</span>
      </button>`).join('');

    montar(`
      <div class="be-card">
        <div class="be-prog">
          <span class="be-prog__num">${String(i + 1).padStart(2, '0')} / ${PREGUNTAS.length}</span>
          <span class="be-prog__pista"><span class="be-prog__barra" data-barra></span></span>
        </div>
        <p class="be-q__tema">${esc(P.tema)}</p>
        <h3 class="be-q__texto">${esc(P.q)}</h3>
        <div class="be-q__ops"${P.cols ? ` data-cols="${P.cols}"` : ''}>${ops}</div>
        <div class="be-q__pieops">
          ${i > 0 ? '<button type="button" class="be-atras" data-atras>&larr; Anterior</button>' : '<span></span>'}
          <span class="be-nota">Elige la opción que más se parezca a ti</span>
        </div>
      </div>
    `, (card) => {
      requestAnimationFrame(() => {
        $('[data-barra]', card).style.width = ((i + 1) / PREGUNTAS.length * 100).toFixed(1) + '%';
      });
      card.querySelectorAll('[data-op]').forEach((b) => {
        b.addEventListener('click', () => {
          respuestas[i] = Number(b.dataset.op);
          sonido.toque();
          card.querySelectorAll('[data-op]').forEach((o) => o.setAttribute('aria-pressed', o === b ? 'true' : 'false'));
          setTimeout(() => {
            if (i + 1 < PREGUNTAS.length) { sonido.paso(); irA(i + 1); }
            else { sonido.informe(); verResultado(); }
          }, 240);
        });
      });
      const atras = $('[data-atras]', card);
      if (atras) atras.addEventListener('click', () => { sonido.atras(); irA(i - 1); });
    });
  }

  /* ======================================================================
     6. CÁLCULO DEL PERFIL
     ====================================================================== */
  function calcular() {
    const dim = {};
    ORDEN_DIMS.forEach((k) => { dim[k] = 55; });

    // Peso de cada respuesta por separado: hace falta distinguir una señal
    // fuerte de muchas señales flojas.
    const pesos = {};
    Object.keys(PRODUCTOS).forEach((k) => { pesos[k] = []; });

    respuestas.forEach((r, i) => {
      if (r === null) return;
      const op = PREGUNTAS[i].ops[r];
      Object.keys(op.d || {}).forEach((k) => { dim[k] += op.d[k]; });
      Object.keys(op.p || {}).forEach((k) => { pesos[k].push(op.p[k]); });
    });

    ORDEN_DIMS.forEach((k) => { dim[k] = Math.round(clamp(dim[k], 8, 100)); });
    const indice = Math.round(ORDEN_DIMS.reduce((s, k) => s + dim[k], 0) / ORDEN_DIMS.length);
    const flojo = ORDEN_DIMS.slice().sort((a, b) => dim[a] - dim[b])[0];
    const fuerte = ORDEN_DIMS.slice().sort((a, b) => dim[b] - dim[a])[0];

    const ranking = Object.keys(pesos).map((k) => {
      const P = PRODUCTOS[k];
      const lista = pesos[k];
      if (!lista.length) return { k, v: 0, area: P.dims[0] };
      const mayor = Math.max.apply(null, lista);
      const resto = lista.reduce((a, b) => a + b, 0) - mayor;
      const base = mayor + resto * 0.35;
      const peorDim = P.dims.reduce((a, d) => (dim[d] < dim[a] ? d : a), P.dims[0]);
      const necesidad = 0.55 + (100 - dim[peorDim]) / 65;
      const prioridad = P.dims.indexOf(flojo) >= 0 ? 1.5 : 1;
      return { k, v: base * necesidad * prioridad, area: peorDim };
    }).filter((o) => o.v > 0).sort((a, b) => b.v - a.v);

    /* De 1 a 4 productos según lo que pida el diagnóstico: entran solo los que
       se acercan al primero. Un perfil sano puede quedarse con uno. */
    const maxV = ranking.length ? ranking[0].v : 1;
    const top = ranking
      .filter((o, i) => i === 0 || o.v >= maxV * 0.62)
      .slice(0, 4)
      .map((o) => ({ k: o.k, area: o.area, match: Math.round(clamp(62 + (o.v / maxV) * 36, 62, 98)) }));

    /* El kit ES el conjunto recomendado. Precio y precio tachado son la suma
       de los productos reales: no se inventa ningún descuento, el ahorro que
       se muestra es el que ya tienen los productos en el catálogo. */
    const precio = top.reduce((s, o) => s + PRODUCTOS[o.k].precio, 0);
    const antes = top.reduce((s, o) => s + PRODUCTOS[o.k].antes, 0);

    return { dim, indice, top, flojo, fuerte, precio, antes };
  }

  const TITULARES = {
    descanso: 'Tu descanso es lo que más te está frenando',
    calma: 'Tu sistema no está bajando revoluciones',
    energia: 'Tu energía es lo primero por resolver',
    cuerpo: 'Tu cuerpo pide más soporte del que recibe',
    digestion: 'Tu digestión es el eslabón que hay que reforzar',
    belleza: 'Tu piel y tu cabello piden refuerzo desde adentro',
    mente: 'Tu foco es el área con más por ganar'
  };
  const NOMBRE_DIM = {
    descanso: 'el descanso', calma: 'la calma', energia: 'la energía', cuerpo: 'el cuerpo',
    digestion: 'la digestión', belleza: 'la piel y el cabello', mente: 'la mente'
  };
  function franja(n) {
    if (n >= 82) return 'Estás en un punto alto. Se trata de sostenerlo.';
    if (n >= 66) return 'Vas bien, con un par de áreas que piden atención.';
    if (n >= 50) return 'Hay una base sólida, pero varias áreas te están restando.';
    return 'Hay margen grande de mejora, y por eso mismo se nota rápido.';
  }

  /* ======================================================================
     7. INFORME
     ====================================================================== */
  function verResultado() {
    paso = PREGUNTAS.length;
    const R = calcular();

    fondo(ACC_FINAL);
    espectro.escena(null, [-0.3, 1.1], ACC_FINAL);
    eyebrow.textContent = 'TU INFORME DE BIENESTAR';
    pie.textContent = 'Perfil completo';
    alDesplazar();

    const cx = 100, cy = 96, R0 = 56;
    const puntos = ORDEN_DIMS.map((k, i) => {
      const a = -Math.PI / 2 + (i / ORDEN_DIMS.length) * Math.PI * 2;
      const rr = R0 * (R.dim[k] / 100);
      return { x: cx + Math.cos(a) * rr, y: cy + Math.sin(a) * rr };
    });
    const poly = puntos.map((p) => `${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(' ');
    const mallas = [0.33, 0.66, 1].map((f) => `<polygon class="be-radar__malla" points="${
      ORDEN_DIMS.map((k, i) => {
        const a = -Math.PI / 2 + (i / ORDEN_DIMS.length) * Math.PI * 2;
        return `${(cx + Math.cos(a) * R0 * f).toFixed(1)},${(cy + Math.sin(a) * R0 * f).toFixed(1)}`;
      }).join(' ')}"/>`).join('');
    const ejes = ORDEN_DIMS.map((k, i) => {
      const a = -Math.PI / 2 + (i / ORDEN_DIMS.length) * Math.PI * 2;
      return `<line class="be-radar__eje" x1="${cx}" y1="${cy}" x2="${(cx + Math.cos(a) * R0).toFixed(1)}" y2="${(cy + Math.sin(a) * R0).toFixed(1)}"/>`;
    }).join('');
    const etiquetas = ORDEN_DIMS.map((k, i) => {
      const a = -Math.PI / 2 + (i / ORDEN_DIMS.length) * Math.PI * 2;
      const x = cx + Math.cos(a) * (R0 + 15);
      const y = cy + Math.sin(a) * (R0 + 15);
      const anchor = Math.abs(Math.cos(a)) < 0.3 ? 'middle' : (Math.cos(a) > 0 ? 'start' : 'end');
      return `<text class="be-radar__lbl" x="${x.toFixed(1)}" y="${(y + 3).toFixed(1)}" text-anchor="${anchor}">${DIMS[k].lbl}</text>`;
    }).join('');

    const barras = ORDEN_DIMS.map((k) => `
      <div class="be-barra__fila">
        <span class="be-barra__lbl">${DIMS[k].lbl}</span>
        <span class="be-barra__pista"><span class="be-barra__val" data-b="${R.dim[k]}" style="--bc:${DIMS[k].color}"></span></span>
        <span class="be-barra__num">${R.dim[k]}</span>
      </div>`).join('');

    const recos = R.top.map((o, i) => `
      <div class="be-reco">
        <img class="be-reco__img" data-prod="${o.k}" src="${imagenDe(PRODUCTOS[o.k].img)}" alt="" loading="lazy">
        <span>
          <span class="be-reco__area" style="--ac:${DIMS[o.area].color}">${DIMS[o.area].lbl}</span>
          <span class="be-reco__nom">${esc(PRODUCTOS[o.k].nom)}</span>
          <span class="be-reco__por">${esc(PRODUCTOS[o.k].por)}</span>
        </span>
        <span class="be-reco__match">${o.match}% afinidad</span>
      </div>`).join('');

    const CIRC = 2 * Math.PI * 76;
    const cuantos = R.top.length === 1 ? 'Un solo producto' : R.top.length + ' productos';

    montar(`
      <div class="be-card">
        <div class="be-res">
          <div class="be-res__cab">
            <div class="be-anillo">
              <svg viewBox="0 0 180 180" aria-hidden="true">
                <defs><linearGradient id="gradAnillo" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stop-color="#7fd4d8"/><stop offset="100%" stop-color="#00e5a0"/>
                </linearGradient></defs>
                <circle class="be-anillo__pista" cx="90" cy="90" r="76"/>
                <circle class="be-anillo__arco" cx="90" cy="90" r="76"
                        stroke-dasharray="${CIRC.toFixed(1)}" stroke-dashoffset="${CIRC.toFixed(1)}" data-arco/>
              </svg>
              <div class="be-anillo__centro">
                <span class="be-anillo__pct"><span data-cuenta>0</span><sup>%</sup></span>
                <span class="be-anillo__cap">Índice de bienestar</span>
              </div>
            </div>
            <div>
              <h3 class="be-res__titulo">${esc(TITULARES[R.flojo])}</h3>
              <p class="be-res__texto">${esc(franja(R.indice))} Tu punto más fuerte es <b>${esc(NOMBRE_DIM[R.fuerte])}</b>; donde más puedes ganar es en <b>${esc(NOMBRE_DIM[R.flojo])}</b>.</p>
            </div>
          </div>

          <div class="be-sep"></div>

          <div>
            <p class="be-res__seccion-tit">El estudio de tus 10 respuestas</p>
            <div class="be-estudio">
              <div class="be-radar">
                <svg viewBox="-24 -8 248 202" aria-label="Perfil en siete áreas">
                  ${mallas}${ejes}
                  <polygon class="be-radar__area" points="${poly}"/>
                  ${puntos.map((p) => `<circle class="be-radar__pt" cx="${p.x.toFixed(1)}" cy="${p.y.toFixed(1)}" r="2.6"/>`).join('')}
                  ${etiquetas}
                </svg>
              </div>
              <div class="be-barras">${barras}</div>
            </div>
          </div>

          <div class="be-sep"></div>

          <div>
            <p class="be-res__seccion-tit">${esc(cuantos)} para ti</p>
            <div class="be-recos">${recos}</div>
          </div>

          <div class="be-kitreco">
            <p class="be-kitreco__cap">TU KIT PERSONALIZADO</p>
            <p class="be-kitreco__nom">${R.top.length} ${R.top.length === 1 ? 'producto' : 'productos'} para ${esc(NOMBRE_DIM[R.flojo])} · ${formatCOP(R.precio)}</p>
            <p class="be-kitreco__desc">${R.top.map((o) => esc(PRODUCTOS[o.k].corto)).join(', ')}. Exactamente lo que salió en tu diagnóstico, nada más.</p>
            <div class="be-acciones"><button type="button" class="be-btn" data-quiero>QUIERO MI KIT</button></div>
          </div>

          <div class="be-acciones"><button type="button" class="be-btn be-btn--fantasma" data-repetir>Volver a hacer el test</button></div>
          <p class="be-legal">Este resultado es una guía de bienestar basada en lo que respondiste. No sustituye la opinión de un profesional de la salud.</p>
        </div>
      </div>
    `, (card) => {
      requestAnimationFrame(() => {
        $('[data-arco]', card).style.strokeDashoffset = (CIRC * (1 - R.indice / 100)).toFixed(1);
        card.querySelectorAll('[data-b]').forEach((el, i) => {
          setTimeout(() => { el.style.width = el.dataset.b + '%'; }, 120 + i * 70);
        });
      });

      const salida = $('[data-cuenta]', card);
      if (menosMovimiento) {
        salida.textContent = R.indice;
      } else {
        const t0 = performance.now(), dur = 1500;
        const tic = (now) => {
          const k = clamp((now - t0) / dur, 0, 1);
          salida.textContent = Math.round(R.indice * (1 - Math.pow(1 - k, 3)));
          if (k < 1) requestAnimationFrame(tic);
        };
        requestAnimationFrame(tic);
      }

      $('[data-repetir]', card).addEventListener('click', () => { sonido.atras(); respuestas.fill(null); verIntro(); });
      $('[data-quiero]', card).addEventListener('click', () => { sonido.abrir(); verKit(R, card); });
    });
  }

  /* ======================================================================
     8. EXTENSIÓN DEL KIT + CAÍDA DE LOS ENVASES
     ----------------------------------------------------------------------
     No abre otra página ni otro cajón: la sección se alarga con el kit
     completo. Los envases que ya se veían en la lista de recomendaciones
     "caen" hasta su hueco del kit y crecen por el camino.
     ====================================================================== */
  function verKit(R, tarjeta) {
    const lleva = R.top.map((o) => o.k);
    const ahorro = R.antes - R.precio;
    const pct = Math.round((ahorro / R.antes) * 100);

    // Cada envase parte de su propia miniatura en las recomendaciones: son los
    // mismos productos, así que todos tienen origen.
    const origenes = {};
    tarjeta.querySelectorAll('[data-prod]').forEach((img) => {
      origenes[img.dataset.prod] = img.getBoundingClientRect();
    });
    const origenKit = $('.be-kitreco', tarjeta).getBoundingClientRect();

    const prods = lleva.map((k) => {
      const P = PRODUCTOS[k];
      return `
        <article class="be-kitprod">
          <img class="be-kitprod__img" data-destino="${k}" src="${imagenDe(P.img)}" alt="${esc(P.nom)}">
          <h4 class="be-kitprod__nom">${esc(P.nom)}</h4>
          <p class="be-kitprod__precio">${formatCOP(P.precio)}</p>
          <p class="be-kitprod__uso"><b>Cómo tomarlo</b>${esc(P.uso)}</p>
        </article>`;
    }).join('');

    cajaKit.innerHTML = `
      <div class="be-kitpanel" data-panel-kit>
        <div class="be-kitpanel__cab">
          <div>
            <p class="be-kitpanel__cap">TU KIT, SEGÚN TU DIAGNÓSTICO</p>
            <h3 class="be-kitpanel__nom">${lleva.length} ${lleva.length === 1 ? 'producto' : 'productos'} para ${esc(NOMBRE_DIM[R.flojo])}</h3>
            <p class="be-kitpanel__desc">${lleva.map((k) => esc(PRODUCTOS[k].corto)).join(', ')}. Sin relleno: solo lo que salió en tu diagnóstico. Se toman durante el día y se acompañan entre sí.</p>
          </div>
          <div class="be-kitpanel__precios">
            ${ahorro > 0 ? `<span class="be-kitpanel__antes">${formatCOP(R.antes)}</span>` : ''}
            <span class="be-kitpanel__ahora">${formatCOP(R.precio)}</span>
            ${ahorro > 0 ? `<span class="be-kitpanel__ahorro">Ahorras ${formatCOP(ahorro)} · ${pct}%</span>` : ''}
          </div>
        </div>

        <div class="be-kitpanel__prods" data-n="${lleva.length}">${prods}</div>

        <div class="be-kitpanel__compra be-acciones">
          <button type="button" class="be-btn be-btn--mint" data-pedir>PÍDELO AHORA</button>
          <span class="be-card__nota">Pagas en efectivo cuando lo recibas en tu casa</span>
          <div class="be-tarjeta__sep"><span>o</span></div>
          <button type="button" class="be-btn be-tarjeta__btn" data-tarjeta>PAGAR CON TARJETA</button>
          <p class="be-tarjeta__nota">
            Con envío <strong>GRATIS</strong> · total <strong>${formatCOP(R.precio)}</strong>
            <span class="be-tarjeta__envio">Tarjeta, PSE y Mercado Pago.</span>
          </p>
        </div>

        <button type="button" class="be-btn be-btn--fantasma be-kitpanel__cerrar" data-cerrar-kit>Cerrar</button>
      </div>`;

    const nodo = $('[data-panel-kit]', cajaKit);
    nodo.scrollIntoView({ behavior: menosMovimiento ? 'auto' : 'smooth', block: 'center' });

    if (!menosMovimiento) volarEnvases(nodo, origenes, origenKit);

    /* El kit personalizado no es un producto de Shopify, así que se agregan
       sus productos uno a uno en una sola llamada. Después se dispara un clic
       sobre un enlace a /cart: be-landing.js intercepta esos clics y abre el
       MISMO cajón contraentrega del resto de la tienda. Montar aquí otro
       carrito sería mantener dos que acaban desincronizados. */
    const items = lleva
      .map((k) => PRODUCTOS[k].vid)
      .filter(Boolean)
      .map((id) => ({ id, quantity: 1 }));

    async function agregarTodo() {
      if (!items.length) return false;
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      return res.ok;
    }

    function abrirCajon() {
      const a = document.createElement('a');
      a.href = '/cart';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      a.remove();
    }

    const btnPedir = $('[data-pedir]', nodo);
    btnPedir.addEventListener('click', async () => {
      sonido.ir();
      const original = btnPedir.textContent;
      btnPedir.disabled = true;
      btnPedir.textContent = 'AGREGANDO…';
      try {
        if (await agregarTodo()) abrirCajon();
        else window.location.href = '/cart';
      } catch (err) {
        window.location.href = '/cart';
      } finally {
        btnPedir.disabled = false;
        btnPedir.textContent = original;
      }
    });

    /* Tarjeta: agrega y entra al checkout por el código de envío gratis, igual
       que el botón equivalente del cajón. */
    const btnTarjeta = $('[data-tarjeta]', nodo);
    btnTarjeta.addEventListener('click', async () => {
      sonido.ir();
      const original = btnTarjeta.textContent;
      btnTarjeta.disabled = true;
      btnTarjeta.textContent = 'UN MOMENTO…';
      try {
        await agregarTodo();
        window.location.href = CFG.urlTarjeta;
      } catch (err) {
        btnTarjeta.disabled = false;
        btnTarjeta.textContent = original;
      }
    });

    $('[data-cerrar-kit]', nodo).addEventListener('click', () => { sonido.atras(); cajaKit.innerHTML = ''; });
  }

  /* Clon en vuelo por cada envase. Se espera un fotograma para medir el
     destino: el panel acaba de insertarse y su animación de apertura todavía
     lo tiene desplazado, así que medir antes daría posiciones falsas. */
  function volarEnvases(nodo, origenes, origenKit) {
    const destinos = [...nodo.querySelectorAll('[data-destino]')];
    destinos.forEach((img) => { img.style.opacity = '0'; });

    setTimeout(() => {
      destinos.forEach((img, i) => {
        const d = img.getBoundingClientRect();
        if (!d.width) { img.style.opacity = ''; return; }
        const o = origenes[img.dataset.destino] || origenKit;

        const clon = img.cloneNode();
        clon.className = 'be-vuela';
        clon.style.left = o.left + 'px';
        clon.style.top = o.top + 'px';
        clon.style.width = o.width + 'px';
        clon.style.height = o.height + 'px';
        document.body.appendChild(clon);

        const dx = d.left + d.width / 2 - (o.left + o.width / 2);
        const dy = d.top + d.height / 2 - (o.top + o.height / 2);
        const escala = d.height / Math.max(1, o.height);

        clon.animate([
          { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
          { transform: `translate(${dx * 0.45}px, ${dy * 0.32}px) scale(${1 + (escala - 1) * 0.35}) rotate(-6deg)`, opacity: 1, offset: 0.45 },
          { transform: `translate(${dx}px, ${dy}px) scale(${escala}) rotate(0deg)`, opacity: 1 }
        ], {
          duration: 900,
          delay: i * 110,
          // caída con rebote al aterrizar
          easing: 'cubic-bezier(0.34, 0.02, 0.2, 1.3)',
          fill: 'forwards'
        }).addEventListener('finish', () => {
          img.style.opacity = '';
          img.animate([{ transform: 'scale(1.06)' }, { transform: 'scale(1)' }], { duration: 260, easing: 'ease-out' });
          clon.remove();
        });
      });
    }, 60);
  }

  /* ====================================================================== */
  /* Silenciador. Se refleja en aria-pressed para que un lector de pantalla
     anuncie el estado, no solo el símbolo. */
  const btnMute = $('[data-mute]', seccion);
  function pintarMute() {
    const on = sonido.activo;
    btnMute.textContent = on ? '♪' : '✕';
    btnMute.setAttribute('aria-pressed', on ? 'false' : 'true');
    btnMute.setAttribute('aria-label', on ? 'Silenciar los sonidos' : 'Activar los sonidos');
    btnMute.style.color = on ? '' : 'rgba(255,255,255,.35)';
  }
  btnMute.addEventListener('click', () => { sonido.alternar(); pintarMute(); });
  pintarMute();

  espectro.iniciar();
  verIntro();
  alDesplazar();
})();
